<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col class="col-md-12 col-sm-12 col-lg-12">
        <b-card>
          <div slot="header">
            ایجاد
            <strong v-text="$lang.competency"></strong>
          </div>
          <div v-show="errors.length > 0" class="alert-danger">
            <h4>خطا:</h4>
            <ul v-bind:key="index" v-for="(error, index) in errors">
              <li>{{ error }}</li>
            </ul>
          </div>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-form-group
              :label="$lang.caption"
              label-for="name"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.caption"
                :rules="$v.name.$params"
              />
              <b-form-input
                id="name"
                type="text"
                :autocomplete="$lang.caption"
                :state="$v.name.$dirty ? !$v.name.$error : null"
                v-model="$v.name.$model"
              ></b-form-input>
              <b-form-invalid-feedback id="name-feedback"
                >{{ $lang.error_required | replace($lang.caption) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.description"
              label-for="description"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.description"
                :rules="$v.description.$params"
              />
              <b-form-textarea
                id="description"
                :state="$v.description.$dirty ? !$v.description.$error : null"
                v-model="$v.description.$model"
                type="text"
                :autocomplete="$lang.description"
                :rows="this.$config.form.textareaRows"
              ></b-form-textarea>
              <b-form-invalid-feedback id="description-feedback"
                >{{ $lang.error_required | replace($lang.description) }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$lang.category"
              label-for="category_id"
              :label-cols="12"
            >
              <requiredComponent
                slot="label"
                :label="$lang.category"
                :rules="$v.category_id.$params"
              />

              <selectFind
                :options="category_options"
                v-model="$v.category_id.$model"
                label="text"
                id="category_id"
                :isValid="$v.category_id.$dirty ? !$v.category_id.$error : null"
                :loading="categoryLoading"
              />

              <b-form-invalid-feedback id="category_id-feedback"
                >دسته بندی ضروری است</b-form-invalid-feedback
              >
            </b-form-group>

            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                {{ $lang.submitButton }}
                <i class="fa fa-check"></i>
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="handleBack"
              >
                {{ $lang.cancelButton }}
                <i class="fa fa-ban"></i>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    name: {
      required,
    },
    description: {
      required,
    },
    category_id: {
      required,
    },
  },
  name: "add-competency",
  components: {},
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoading: false,
      name: "",
      description: "",
      category_options: [],
      exercise_options: [],
      category_id: null,
      exercise_id: null,
      categoryLoading: false,
      errors: [],
    };
  },
  methods: {
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.description = "";
      this.category_id = null;
      this.exercise_id = null;
    },
    changes() {},
    getCompetencyCategory() {
      return this.$httpService
        .get(this.$config.api_url + this.$config.metaData.competency_category)
        .then((response) => {
          if (response.status != 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let competency_category = response.data.data;
          competency_category = competency_category.map((x) => {
            return {
              value: x.enum_id,
              text: x.enum_caption,
            };
          });
          this.category_options = competency_category;
        })
        .catch((err) => {
          this.$notify.error(err.message);
        });
    },
    getExercise() {
      this.$httpService
        .get(this.$config.api_url + this.$config.kanoon.exercise)
        .then((response) => {
          if (response.status != 200) {
            this.$notify.error(response.data.message);
            return;
          }
          let exercise = response.data.data.data;
          exercise = exercise.map((x) => {
            return {
              value: x.id,
              text: x.name,
            };
          });
          this.exercise_options = exercise;
        })
        .catch((err) => {
          this.$notify.error(err.message);
        });
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      this.isLoading = true;
      let payload = {
        name: this.name,
        description: this.description,
        category_id: this.category_id.value,
      };
      this.$httpService
        .post(this.$config.api_url + this.$config.kanoon.competency, payload)
        .then((response) => {
          this.$notify.success(response.data.message);
          this.afterSave();
        })
        .catch((err) => {
          if (err.response.status === 400) {
            if (typeof err.response.data.message === "object") {
              err.response.data.message.forEach((element) => {
                this.errors.push(element);
              });
            } else {
              this.$notify.error(err.response.data.message);
            }
          } else {
            this.$notify.error(err.message);
          }

          this.isLoading = false;
        });
    },
  },
  created() {
    this.categoryLoading = true;
    this.getCompetencyCategory().finally(() => (this.categoryLoading = false));
  },
};
</script>

<style scoped lang="css">
.btn {
  margin-bottom: 4px;
}
</style>
